import React, { useState,  forwardRef, useContext, useEffect } from 'react';
import axios from 'axios';
import { AuthorizeContext } from "../../RootContext";
import { Link, useParams } from 'react-router-dom';
import { api_url } from "../../authorize";
import logo from './../../img/lento_logo.jpg';

import MaterialTable from 'material-table';
import Input from '@material-ui/core/Input';
import { createMuiTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import MenuItem from '@material-ui/core/MenuItem';
import Select from 'react-select'; // Add this line at the top

import Button from '@material-ui/core/Button';
import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import InfoIcon from '@material-ui/icons/Info';
import Modal from '@material-ui/core/Modal';

  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} fontSize="large"/>),
    Permissions: forwardRef((props, ref) => <InfoIcon {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };

  const useStyles = makeStyles({
    root: {
      background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
      border: 0,
      borderRadius: 3,
      boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
      color: 'white',
      height: 48
    },
  });

  const theme = createMuiTheme({
    typography: { h6: {fontSize: '1.4em'}},
  });

const ManuLocation = () => {

  // const [data, setData] = useState({})
  const { token, authBody, setAuthenticated, setAuthBody } = useContext(AuthorizeContext);
  const [profile, setProfile] = useState(authBody || {role: "visitor"})
  const [loading, setLoading] = useState(true)
  const hasRole = (profile, roles) =>{
    return roles.includes(profile.role)
  }
  let ssss;
  let cccc;
  let { surgeonid } = useParams()
  const [open, setOpen] = useState(false)
  const handleOpen =() => {
    setOpen(true)
  }

  useEffect(() => {
    const fetchData = async () => {
      const res = await axios({
        url: `https://${api_url}/api/manufacturer_mapping`,
        method: 'get',
        headers: {
          'x-access-token' : token
        }
      }).then(res=> {
        if(res.data.message){
          alert(res.data.message)
        }
        else if(res.data.validation){
          alert(res.data.validation.replace("_", " "))
        }
        else if(res.data.notLoggedIn){
          setAuthenticated(false)
          setAuthBody({role: 'visitor'})
          alert("You have been logged out due to inactivity. Please log in again.")
        }
        else{
          setLoading(false)
          setState((prevState) => ({
            ...prevState, data: res.data.manus, //ssss: res.data.partners, cccc: res.data.countries
          }));
          ssss = res.data.partners;
          cccc = res.data.countries;
          console.log(res.data);
          console.log(state.data);
          // const dadata = res.data.manus
        }
      });
    };
    fetchData();
  }, []);

  const onChange = (e) => {
    const { name, value } = e.target
    setState({...state,
      [name] : value
    })
  }

  console.log(state)

// const ssss = state.data.partners
// const ssss = ["Link","Lento","MDREX","Lento_ITA"]
// const cccc = state.data.partners
// const cccc = ['POR', 'CRO', 'USA','GER', 'ITA']

 const ddd = [
    { site: 'Lento', country_list: ['POR', 'CRO', 'USA']},
    { site: 'Link', country_list: ['GER', 'ITA'] },
    { site: 'Lento_ITA', country_list: [] },
  ];

  const [state, setState] = useState({
    columns: [
      { title: 'Partner', field:'site', filtering: false, width: '1%', editable:"onAdd",
         editComponent: (props) =>  (
        <select
          value={props.value || ''}
          onChange={e => props.onChange(e.target.value)}
          style={{ width: '100%' }}
        >
            <option value="">NONE</option>

          {ssss.map((ss, index) => (
          <option key={index} value={ss.First_Name}>{ss.First_Name}</option>
      ))},
        </select>
        ),
         cellStyle: {
            fontSize: '1em'
          }
      },
      
       { title: 'Hospital Locations', field:'country_list', filtering: false, width: '1%', editable:false,
        render: (rowData) => (
        <div style={{ display: 'flex', gap: '4px' }}>
          {rowData.country_list.map((country, index) => (
            <span key={index} style={{ padding: '2px 6px', background: '#eee', borderRadius: '4px', width: 'fit-content' }}>
              {country}
            </span>
          ))}
        </div>
      ),
          cellStyle: {
            fontSize: '.7em'
          }
      },

      { title: 'Add Location', field:'locadd', filtering: false, width: '1%',
          cellStyle: {
            fontSize: '.7em'
          },
      editComponent: (props) =>  {
        console.log(JSON.stringify(props.rowData));
         if (JSON.stringify(props.rowData).includes("tableData")){
         return(
        <select
          value={props.value || ''}
          onChange={e => props.onChange(e.target.value)}
          style={{ width: '100%' }}
        >
            <option value="">Nothing to Add</option>
          {cccc.filter(val => !props.rowData.country_list.includes(val)).map((t,i) =>(
            <option key={i} value={t}>Add {t}</option>
          ))},
        </select>
      );
    }
    else{
        return (
            <div >Add Locations After Creating</div>
          )
      }
  }
      },

      { title: 'Remove Location', field:'locrem', filtering: false, width: '1%',
          cellStyle: {
            fontSize: '.7em'
          },
           editComponent: (props) =>  {
        console.log(JSON.stringify(props.rowData));
         if (JSON.stringify(props.rowData).includes("tableData")){
          return(

        <select
          value={props.value || ''}
          onChange={e => props.onChange(e.target.value)}
          style={{ width: '100%' }}
        >
            <option value="">Nothing to Remove</option>

          {props.rowData.country_list.map((ss, index) => (
          <option key={index} value={ss}>Remove {ss}</option>
      ))},
        </select>
        );
      }
      else{
        return (
            <div >Nothing to Remove on New Partner</div>
          )
      }
    }
    },
      
      { title: 'Available', field: 'available', type: "boolean"},
      
    ]
  });

  const handleChange = event => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };


  const classes = useStyles();
  if(loading){
    return(
      <div id="p5_loading" style={{position:"relative", width: '100%', zIndex: '3',
              height: "100%", left: 0, top: 0, backgroundColor: "white"
            }}>
          <img src={logo} alt="logo"
          style={{display: "block", marginLeft: "auto", marginRight: "auto", width:"50%"}}
          />
      </div>

    )
  }

    return(
      <>
      <div className="w-50 mx-auto mt-5" >
      {
      hasRole(profile, ['super_admin']) ?
      <MaterialTable
        title="Manufacturing Mapping"
        columns={state.columns}
        data={state.data}
        icons={tableIcons}
        editable={
          {
          onRowUpdate: (newData, oldData) =>
             new Promise((resolve, reject) => {
               setTimeout(() => {
                 {
                   resolve();
                   const data = [...state.data];
                   const index = data.indexOf(oldData);
                   data[index] = newData;
                   setState({ ...state, data });
                   console.log(newData)
                   console.log(data)
                   console.log(state)
                   axios({
                     url: `https://${api_url}/api/manufacturer_mapping?login=${oldData.login}`,
                     method: 'put',
                      data:
                     {
                        "site" : newData.site,
                        "available": newData.available,
                        "country_list": newData.country_list,
                        "locadd": newData.locadd,
                         "locrem": newData.locrem,
                          },
                     headers: {
                       'x-access-token' : token
                     }
                   }).then(res=> {
                   console.log(res);
                     if(res.data){
                       alert(res.data.message)
                     }
                     else if(res.data.validation){
                       alert(res.data.validation.replace("_", " "))
                     }
                     else if(res.data.notLoggedIn){
                       setAuthenticated(false)
                       setAuthBody({role: 'visitor'})
                       alert("You have been logged out due to inactivity. Please log in again.")
                     }
                     else{

                     window.location.reload();
                     }
                   });

               }
             }, 1000);
             }),
          onRowAdd: newData =>
            new Promise((resolve, reject) => {
              setTimeout(() => {
                  const data = [...state.data];
                  axios({
                    url:`https://${api_url}/api/manufacturer_mapping`,
                    method: 'post',
                    data:
                     {
                        "site" : newData.site,
                        "available": false,
                        "country_list": [],
                        "locadd": newData.locadd,
                         "locrem": newData.locrem,
                          },
                    headers: {
                       'x-access-token' : token
                    }
                  }).then(
                    res => {
                      if(res.data){
                        // alert(data)
                        alert(res.data.message)
                      }
                      else if(res.data.validation){
                        alert(res.data.validation.replace("_", " "))
                      }
                      else if(res.data.notLoggedIn){
                        setAuthenticated(false)
                        setAuthBody({role: 'visitor'})
                        alert("You have been logged out due to inactivity. Please log in again.")
                      }
                      else{
                        data.push(newData)
                        setState({...state, data})
                      window.location.reload();
                      }
                    }
                  )
                resolve()
              }, 1000)

            }),
         
      }}
        localization={{
            pagination: {
                labelDisplayedRows: '{from}-{to} of {count}'
            },
            toolbar: {
                nRowsSelected: '{0} row(s) selected'
            },
            header: {
                actions: 'Actions'
            },
            body: {
                emptyDataSourceMessage: 'No records to display',
                filterRow: {
                    filterTooltip: 'Filter'
                }
            }
        }}
        options={{
          actionsColumnIndex: 9,
          sorting: true,
          filtering: true,
          headerStyle: {
            fontSize: '.8em'
          }
        }}
        style={{
          fontSize: '20px'
        }}
        />

        :

        (
          hasRole(profile, ['write_admin']) ?
          <MaterialTable
            title="Manufacturing Mapping"
            columns={state.columns}
            data={state.data}
            icons={tableIcons}
            editable={
              {
              onRowUpdate: (newData, oldData) =>
                 new Promise((resolve, reject) => {
                   setTimeout(() => {
                     {
                       resolve();
                       const data = [...state.data];
                       const index = data.indexOf(oldData);
                       data[index] = newData;
                       setState({ ...state, data });
                       console.log(newData)
                       console.log(data)
                       console.log(state)
                       axios({
                         url: `https://${api_url}/api/manufacturer_mapping?login=${newData.login}`,
                         method: 'put',
                        data:
                     {
                        "site" : newData.site,
                        "available": newData.available,
                        "country_list": newData.country_list,
                        "locadd": newData.locadd,
                         "locrem": newData.locrem,
                          },
                         headers: {
                           'x-access-token' : token
                         }
                       }).then(res=> {
                         console.log("dog");
                         console.log("dog", res.data)
                         window.location.reload();
                       })
                       ;

                   }
                 }, 1000);
                 }),
              onRowAdd: newData =>
                new Promise((resolve, reject) => {
                  setTimeout(() => {
                      const data = [...state.data];
                      axios({
                        url:`https://${api_url}/api/manufacturer_mapping`,
                        method: 'post',
                        data:
                     {
                        "site" : newData.site,
                        "available": false,
                        "country_list":[],
                        "locadd": newData.locadd,
                         "locrem": newData.locrem,
                          },
                        headers: {
                           'x-access-token' : token
                        }
                      }).then(
                        res => {
                          data.push(newData)
                          setState({...state, data})
                          console.log("shoe")
                          console.log(res.data);
                          window.location.reload();
                        }
                      )
                    resolve()
                  }, 1000)

                })
            }
          }
            localization={{
                pagination: {
                    labelDisplayedRows: '{from}-{to} of {count}'
                },
                toolbar: {
                    nRowsSelected: '{0} row(s) selected'
                },
                header: {
                    actions: 'Actions'
                },
                body: {
                    emptyDataSourceMessage: 'No records to display',
                    filterRow: {
                        filterTooltip: 'Filter'
                    }
                }
            }}
            options={{
              actionsColumnIndex: 9,
          filtering: true,
              sorting: true,
              headerStyle: {
                fontSize: '.8em'
              }
            }}
            style={{
              fontSize: '20px'
            }}
            />
          :

          <MaterialTable
            title="Manufacturing Mapping"
            columns={state.columns}
            data={state.data}
            icons={tableIcons}
            localization={{
                pagination: {
                    labelDisplayedRows: '{from}-{to} of {count}'
                },
                toolbar: {
                    nRowsSelected: '{0} row(s) selected'
                },
                header: {
                    actions: 'Actions'
                },
                body: {
                    emptyDataSourceMessage: 'No records to display',
                    filterRow: {
                        filterTooltip: 'Filter'
                    }
                }
            }}
            options={{
              actionsColumnIndex: 9,
          filtering: true,
              sorting: true,
              headerStyle: {
                fontSize: '.8em'
              }
            }}
            style={{
              fontSize: '20px'
            }}
            />
        )
      }

      </div>
      
      </>

    );
};

export default ManuLocation;
